export default __webpack_public_path__ + "static/media/models4.37cd913e.jfif";